import {
  GatsbyImage,
  GatsbyImageProps,
  IGatsbyImageData,
} from "gatsby-plugin-image"
import React, { CSSProperties } from "react"
import styled from "styled-components"
import { AppFunctionComponent } from "../../types"

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `StaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.dev/gatsby-image
 * - `StaticQuery`: https://gatsby.dev/staticquery
 */

const StyledGatsbyImage = styled(GatsbyImage)<GatsbyImageProps>`
  overflow: hidden;
  position: relative;
  img {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    object-fit: contain;
    object-position: center;
  }
`

interface ImageProps {
  alt?: string
  image: IGatsbyImageData
  loading?: "lazy" | "eager"
  className?: string
}

export const Image: AppFunctionComponent<ImageProps> = ({
  image,
  alt = "",
  className = "",
  loading = "lazy",
}) => {
  const defaultStyles: CSSProperties = {
    position: undefined,
    top: "",
    left: "",
    objectFit: undefined,
    objectPosition: "",
    width: "",
    height: "",
    overflow: "",
  }

  return (
    <StyledGatsbyImage
      image={image}
      className={className}
      imgStyle={defaultStyles}
      style={{
        position: undefined,
        overflow: "",
      }}
      alt={alt}
      loading={loading}
    />
  )
}
